import { jsx as _jsx } from "react/jsx-runtime";
export const BxsCloudUpload = (props) => {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", ...props, children: _jsx("path", { d: "M18.944,11.112C18.507,7.67,15.56,5,12,5C9.244,5,6.85,6.611,5.757,9.15C3.609,9.792,2,11.82,2,14c0,2.757,2.243,5,5,5h3h1\th2h1h4c2.206,0,4-1.794,4-4C22,13.12,20.695,11.538,18.944,11.112z M13,14v3h-2v-3H8l4-5l4,5H13z" }) }));
};
